module.exports = __webpack_public_path__ + "img/banner-list.0233dcc7.png";